// utils
import PadEditorEquipment from './class/PadEditorEquipment';
// config
import { PAD_ITEM_TYPE } from 'app/config/pad_item.js';

const TEMPLATE_NAME = 'PAD_EDITOR_EQUIPMENT';

const initialState = {
  loading: false,
  errors: [],
  data: {
    loaded: [],
    screen: []
  }
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case `${TEMPLATE_NAME}_PENDING`: {
      const padEditorEquipment = new PadEditorEquipment(state);

      return padEditorEquipment.setLoading().setErrors().getState();
    }

    case `${TEMPLATE_NAME}_FULFILLED`: {
      const equipments = action.payload;

      const padEditorEquipment = new PadEditorEquipment(state);

      return padEditorEquipment.prepare(equipments).setLoading(false).getState();
    }

    case `${TEMPLATE_NAME}_REJECTED`: {
      const errors = action.payload.errors;

      const padEditorEquipment = new PadEditorEquipment(state);

      return padEditorEquipment.setErrors(errors).setLoading(false).getState();
    }

    case `${TEMPLATE_NAME}_ADD`: {
      const equipment = action.payload.data;
      const padEditorEquipment = new PadEditorEquipment(state);

      return padEditorEquipment.insert(equipment, { type: PAD_ITEM_TYPE.EQUIPMENT }).getState();
    }

    case `${TEMPLATE_NAME}_EDIT`: {
      const equipment = action.payload.data;
      const { code } = equipment;
      const padEditorEquipment = new PadEditorEquipment(state);

      return padEditorEquipment.update(code, equipment).getState();
    }

    case `${TEMPLATE_NAME}_REMOVE`: {
      const equipment = action.payload.data;
      const { code } = equipment;
      const padEditorEquipment = new PadEditorEquipment(state);

      return padEditorEquipment.remove(code).getState();
    }

    case `${TEMPLATE_NAME}_CHANGE_STATUS`: {
      const equipment = action.payload.data;
      const { code, status: prevStatus } = equipment;
      let status = prevStatus ? 0 : 1;

      const padEditorEquipment = new PadEditorEquipment(state);

      return padEditorEquipment.update(code, { status }).getState();
    }

    case `${TEMPLATE_NAME}_RESET`: {
      return initialState;
    }

    default: {
      return state;
    }
  }
};

export default reducer;
